module.exports = __webpack_public_path__ + "img/hontai_SummerYellow.e8bca99a.png";